export const FORM_LIMITS = {
    DISPLAY_NAME_MAX: 50,
    DESCRIPTION_MAX: 120
}
